import React from "react";
import { useSiteContent } from "@/context/SiteContentContext";

export function BrandMark({ className = "" }) {
  const { content } = useSiteContent();
  const b = content.brand || {};
  return (
    <span className={className}>
      {b.name || "Auto"}
      <span className="text-electric">{b.name_highlight || "Park"}</span>
    </span>
  );
}
